import React from 'react';
import '../App.css';

const DeleteDocumentModal = ({ isOpen, onClose, onConfirm, documentName }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Delete Document</h2>
        <p>Are you sure you want to delete "{documentName}"? This action cannot be undone.</p>
        <div className="modal-buttons">
          <button className="cancel-button" onClick={onClose}>
            Cancel
          </button>
          <button className="delete-button" onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteDocumentModal; 